/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import type { App } from 'vue'
import PrimeVue from 'primevue/config'
import { InputTextWrapper } from '@/core/components'
import { locales } from './locales'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'

import '@/core/assets/css/tailwind.css'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{violet.50}',
      100: '{violet.100}',
      200: '{violet.200}',
      300: '{violet.300}',
      400: '{violet.400}',
      500: '{violet.500}',
      600: '{violet.600}',
      700: '{violet.700}',
      800: '{violet.800}',
      900: '{violet.900}',
      950: '{violet.950}',
    },
  },
})

const config = {
  ripple: true,
  theme: {
    preset: MyPreset,
    options: {
      cssLayer: false,
    },
  },
}

export const loadPrimeVue = (app: App) => {
  app.use(PrimeVue, {
    ...config,
    locale: locales.es,
  })

  app.use(ToastService)
  app.use(ConfirmationService)
  app.component('InputTextWrapper', InputTextWrapper)
}

export default PrimeVue
